import {
  Component,
  OnInit,
  Input,
  TemplateRef,
  ViewChild,
  AfterViewInit,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {
  PopoverModule,
  PopoverContainerComponent,
  PopoverDirective,
} from 'ngx-bootstrap/popover';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'glm-select',
  templateUrl: './select.component.html',
  styleUrls: ['./select.component.css'],
})
export class SelectComponent implements OnInit, AfterViewInit, OnChanges {
  constructor(private breakpointObserver: BreakpointObserver) {}

  @Input() title = null;
  @Input() value = 'All';
  @Input() closedState = true;

  @ViewChild(PopoverDirective) popOverDirective;
  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  ngOnInit(): void {}
  ngOnChanges(simpleChanges: SimpleChanges) {
    if (this.popOverDirective) {
      if (simpleChanges['closedState']) {
        this.popOverDirective.toggle();
      }
    }
  }

  ngAfterViewInit() {}
  close(template: TemplateRef<any>) {
    //@ts-ignore
    template.hide();
  }
}
